module.exports = "/assets/cola-page/photo.png?B5fP4Ut";